// src/components/Contact/ContactField.js
import React from 'react';
import { TextField } from '@aws-amplify/ui-react';

const ContactField = ({ value, onChange, className }) => (
  <div className={`form-field grid-field ${className || ''}`}>
    <label className="amplify-label">
      Contact <span className="required-star">*</span>
    </label>
    <TextField
      label=""
      labelHidden
      type="text"
      value={value}
      onChange={onChange}
      required
      variation="quiet"
    />
  </div>
);

export default ContactField;
